import { useStore, create } from "zustand";
import { PointLike } from "mapbox-gl";

import { AmpolService } from "./types";

type Indicated = {
  $ids: AmpolService["$id"][];
  point?: PointLike;
} | null;
type SetIndicatedCallback = (prev: Indicated) => Indicated;

interface IndicationStore {
  indication: Indicated;
  setIndication: (value: Indicated | SetIndicatedCallback) => void;
}

const indicationStore = create<IndicationStore>()((set, get) => ({
  indication: null,
  setIndication: (t: Indicated | SetIndicatedCallback) => {
    if (typeof t === "function") {
      const prev = get().indication;
      const next = t(prev);
      if (prev !== next) {
        set({ indication: next });
      }
    } else {
      set({ indication: t });
    }
  },
}));

function useIndicationStore(): IndicationStore;
function useIndicationStore<T>(
  selector: (state: IndicationStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useIndicationStore<T>(
  selector?: (state: IndicationStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(indicationStore, selector!, equals);
}

export default useIndicationStore;
